export default "__VITE_ASSET__BiZAE$Eh__"